import { getAccessTokenExpiration } from './getAccessTokenExpiration';

/**
 * When refreshing an auth token, if the user passes an invalid token the
 * server responds with an invalid JWT. This function validates that the
 * JWT returned is a valid access token. Currently we do this by checking
 * that there is an expiration date in the token.
 * @param accessToken
 * @returns boolean;
 */
export const isValidAccessToken = (accessToken?: string): boolean => {
  if (!accessToken || typeof accessToken !== 'string') {
    return false;
  }

  try {
    const expiresAt = getAccessTokenExpiration(accessToken);
    return Boolean(expiresAt);
  } catch {
    return false;
  }
};
